import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	title: string;
	image: string;
	onClick: () => void;
};

export const InspirationCardButton: FC<Props> = ({ title, image, onClick }) => {
	const { inspiration, palette } = useTheme();

	return (
		<ButtonBase
			onClick={onClick}
			sx={{
				flexShrink: 0,
				width: inspiration.card.width,
				height: inspiration.card.height,
				borderRadius: inspiration.card.borderRadius,
				overflow: "hidden",
				position: "relative",
				display: "flex",
				alignItems: "flex-end",
				justifyContent: "flex-start",
				p: inspiration.card.padding,
				textAlign: "left",
				"&:active": { transform: inspiration.card.activeTransform },
			}}
		>
			<Box
				component="img"
				src={image}
				alt={title}
				draggable={false}
				position="absolute"
				width="100%"
				height="100%"
				sx={{ inset: 0, objectFit: "cover" }}
			/>
			<Box
				position="absolute"
				sx={{ inset: 0, background: inspiration.card.overlayGradient }}
			/>
			<Typography
				variant="bodyStrong"
				position="relative"
				lineHeight={inspiration.card.titleLineHeight}
				color={palette.darkmodeText.white}
				sx={{ textShadow: inspiration.card.textShadow }}
			>
				{title}
			</Typography>
		</ButtonBase>
	);
};
